var render = function () {
  var _vm$selectedSpecimen$, _vm$selectedSpecimen$2, _vm$selectedSpecimen$3, _vm$selectedSpecimen$4, _vm$selectedSpecimen$5, _vm$selectedSpecimen$6, _vm$selectedSpecimen$7, _vm$selectedSpecimen$8, _vm$selectedSpecimen$9, _vm$selectedSpecimen$10, _vm$selectedSpecimen$11, _vm$selectedSpecimen$12;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._l(_vm.formData.widgets, function (widgetMetadata, index) {
    return _c('widget-component', {
      key: index,
      attrs: {
        "widgetMetadata": widgetMetadata
      }
    });
  }), _vm.caseNumber ? _c('v-expansion-panels', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, _vm._l(_vm.caseNumber.protocolNumbers, function (protocolNumber, i) {
    return _c('v-expansion-panel', {
      key: ("pn" + i)
    }, [_c('v-expansion-panel-header', [_vm._v(" " + _vm._s(protocolNumber.protocolNumber) + " ")]), _c('v-expansion-panel-content', [_c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.tableMetadata.headers,
        "items": protocolNumber.specimens,
        "items-per-page": 10
      },
      scopedSlots: _vm._u([{
        key: "top",
        fn: function () {
          return [_c('v-toolbar', {
            attrs: {
              "flat": ""
            }
          }, [_c('v-toolbar-title', [_vm._v("Specimens")]), _c('v-spacer'), _c('v-btn', {
            staticClass: "mb-2",
            attrs: {
              "color": "primary",
              "dark": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.onShowAddProtocolNumberSpecimen(protocolNumber);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" New Specimen ")], 1)], 1)];
        },
        proxy: true
      }, {
        key: "item.actions",
        fn: function (_ref) {
          var item = _ref.item;
          return _vm._l(_vm.tableMetadata.actions, function (action, i) {
            return _c('v-btn', {
              key: ("btn" + i),
              attrs: {
                "text": "",
                "small": ""
              },
              on: {
                "click": function ($event) {
                  return action.onClick(item, protocolNumber);
                }
              }
            }, [_c('v-icon', {
              staticClass: "mr-2",
              attrs: {
                "color": action.color
              }
            }, [_vm._v(" " + _vm._s(action.icon) + " ")])], 1);
          });
        }
      }], null, true)
    })], 1)], 1);
  }), 1)], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.dialog.showSpecimenDetails,
      callback: function ($$v) {
        _vm.$set(_vm.dialog, "showSpecimenDetails", $$v);
      },
      expression: "dialog.showSpecimenDetails"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog.showSpecimenDetails = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.selectedProtocolNumber.protocolNumber) + " :: " + _vm._s(_vm.selectedSpecimen.code) + " :: Details ")])], 1), _c('br'), _c('v-container', [_c('v-list', [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$ = _vm.selectedSpecimen.specimenSource) === null || _vm$selectedSpecimen$ === void 0 ? void 0 : _vm$selectedSpecimen$.name) + " ")]), _c('v-list-item-subtitle', [_vm._v("Specimen Source")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$2 = _vm.selectedSpecimen.sampleFrom) === null || _vm$selectedSpecimen$2 === void 0 ? void 0 : _vm$selectedSpecimen$2.name) + " ")]), _c('v-list-item-subtitle', [_vm._v("Method of Collection")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$3 = _vm.selectedSpecimen.specimenType) === null || _vm$selectedSpecimen$3 === void 0 ? void 0 : _vm$selectedSpecimen$3.name) + " ")]), _c('v-list-item-subtitle', [_vm._v("Specimen Type")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$4 = _vm.selectedSpecimen.specimenState) === null || _vm$selectedSpecimen$4 === void 0 ? void 0 : _vm$selectedSpecimen$4.name) + " ")]), _c('v-list-item-subtitle', [_vm._v("Preparation")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v(" Location ")]), _c('v-expansion-panel-content', [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$5 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$5 === void 0 ? void 0 : _vm$selectedSpecimen$5.freezer) + " ")]), _c('v-list-item-subtitle', [_vm._v("Freezer No.")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$6 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$6 === void 0 ? void 0 : _vm$selectedSpecimen$6.temperature) + " ")]), _c('v-list-item-subtitle', [_vm._v("Temperature")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$7 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$7 === void 0 ? void 0 : _vm$selectedSpecimen$7.shelfNumber) + " ")]), _c('v-list-item-subtitle', [_vm._v("Shelf No.")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$8 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$8 === void 0 ? void 0 : _vm$selectedSpecimen$8.rackNumber) + " ")]), _c('v-list-item-subtitle', [_vm._v("Rack No.")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$9 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$9 === void 0 ? void 0 : _vm$selectedSpecimen$9.slidingRackNumber) + " ")]), _c('v-list-item-subtitle', [_vm._v("Sliding Rack No.")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$10 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$10 === void 0 ? void 0 : _vm$selectedSpecimen$10.boxNumber) + " ")]), _c('v-list-item-subtitle', [_vm._v("Box Number")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s((_vm$selectedSpecimen$11 = _vm.selectedSpecimen.location) === null || _vm$selectedSpecimen$11 === void 0 ? void 0 : _vm$selectedSpecimen$11.boxLocation) + " ")]), _c('v-list-item-subtitle', [_vm._v("Box Location")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), (_vm$selectedSpecimen$12 = _vm.selectedSpecimen.barcode) !== null && _vm$selectedSpecimen$12 !== void 0 && _vm$selectedSpecimen$12.url ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_c('img', {
    staticStyle: {
      "max-width": "800px",
      "max-height": "400px"
    },
    attrs: {
      "src": _vm.selectedSpecimen.barcode.url
    }
  })]), _c('v-list-item-subtitle', [_vm._v("Barcode")])], 1)], 1) : _vm._e()], 1), _c('h2', [_vm._v("Transactions")]), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.transactionTableMetadata.headers,
      "items": _vm.selectedSpecimen.transactions,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('v-toolbar', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-toolbar-title', [_vm._v("Transactions")]), _c('v-spacer'), _c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.onOpenTransactionForm();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" New Transaction ")], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.actions",
      fn: function (_ref2) {
        var item = _ref2.item;
        return _vm._l(_vm.transactionTableMetadata.actions, function (action, i) {
          return _c('v-btn', {
            key: ("btn" + i),
            attrs: {
              "text": "",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return action.onClick(_vm.selectedSpecimen, item);
              }
            }
          }, [_c('v-icon', {
            staticClass: "mr-2",
            attrs: {
              "color": action.color
            }
          }, [_vm._v(" " + _vm._s(action.icon) + " ")])], 1);
        });
      }
    }], null, true)
  }), _c('v-dialog', {
    attrs: {
      "max-width": "600",
      "persistent": ""
    },
    model: {
      value: _vm.dialog.showTransaction,
      callback: function ($$v) {
        _vm.$set(_vm.dialog, "showTransaction", $$v);
      },
      expression: "dialog.showTransaction"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v(" Transaction ")]), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingSpecimen
    }
  }), _vm.dialog.showTransaction ? _c('form-component', {
    ref: "specimenTransactionForm",
    attrs: {
      "formData": _vm.transactionFormData
    }
  }) : _vm._e(), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.onHideTransactionForm();
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.dialog.upsertSpecimen,
      callback: function ($$v) {
        _vm.$set(_vm.dialog, "upsertSpecimen", $$v);
      },
      expression: "dialog.upsertSpecimen"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog.upsertSpecimen = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.selectedProtocolNumber.protocolNumber) + " :: "), !_vm.specimenFormData.model ? _c('span', [_vm._v(" Create ")]) : _vm._e(), _vm.specimenFormData.model ? _c('span', [_vm._v(" " + _vm._s(_vm.specimenFormData.model.code) + " :: Edit ")]) : _vm._e()]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.onClickSpecimenSave();
      }
    }
  }, [_vm._v(" Save ")])], 1)], 1), _c('br'), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingSpecimen
    }
  }), _vm.dialog.upsertSpecimen ? _c('form-component', {
    ref: "specimenForm",
    attrs: {
      "formData": _vm.specimenFormData
    },
    scopedSlots: _vm._u([{
      key: "additional-info-section",
      fn: function () {
        var _vm$caughtInfoValues;

        return [_c('div', {
          staticClass: "specimen-info-container"
        }, [_c('label', {
          staticClass: "specimen-info-label"
        }, [_vm._v(" Specimen Additional Info (If Applicable) ")]), (_vm$caughtInfoValues = _vm.caughtInfoValues) !== null && _vm$caughtInfoValues !== void 0 && _vm$caughtInfoValues.length ? _c('nested-question', {
          attrs: {
            "display": 'main',
            "questionsMetadata": {
              questionRawList: _vm.questionsMetadata.questionRawList,
              questionList: _vm.questionsMetadata.questionList,
              widgets: _vm.questionsMetadata.widgets,
              parentWidget: _vm.questionsMetadata.widgets,
              catchValue: _vm.questionsMetadata.catchValue
            }
          }
        }) : _vm._e(), _c('v-btn', {
          staticClass: "add-info-button",
          attrs: {
            "color": "primary",
            "dark": "",
            "block": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.onClickAddInfo();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Add Specimen info ")], 1)], 1)];
      },
      proxy: true
    }], null, false, 2259020692)
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": "",
      "clearable": "",
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.onClickSpecimenSave();
      }
    }
  }, [_vm._v(" Save ")])], 1) : _vm._e()], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }